import { gql } from '@apollo/client';

export const unscheduledAppointmentsName = 'UnscheduledAppointments';
export const unscheduledAppointments = gql`
	fragment ${unscheduledAppointmentsName} on Member {
		unscheduledAppointments {
			id
			cogsworthId
			memberId
			appointmentType
			rescheduleUrl
		}
	}
`;
